import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { Box, Button, Flex, RiArrowRightSLine } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import { useCallback } from "react";
import { useMessageSelectedContext } from "~/components/common/chat/ChatPagesContainer";
import { PATH as CLIENT_PATH } from "~/pages/deals/[id]";
import { PATH as VENDOR_PATH } from "~/pages/vendors/deals/[id]";
import Styles from "./ChatMessagePaneHeader.module.scss";

type Props = DeepReadonly<{
	handleTemporaryUnread: (dealId: number) => Promise<void>;
	isAdmin?: boolean;
	isDisabledUnreadButton: boolean;
	isVendor?: boolean;
}>;

export const ChatMessagePaneHeader: React.FC<Props> = ({
	isVendor = false,
	isAdmin = false,
	isDisabledUnreadButton,
	handleTemporaryUnread
}: Props) => {
	const summary = useMessageSelectedContext().selectedSummary!;

	const setSummary = useMessageSelectedContext().setSelectedSummary!;
	const onClickClose = useCallback(
		(e: React.MouseEvent): void => {
			e.preventDefault();
			setSummary(null);
		},
		[setSummary]
	);
	const onClickTemporaryUnread = useCallback((): void => {
		handleTemporaryUnread(summary.deal.id);
		setSummary(null);
	}, [handleTemporaryUnread, summary.deal.id, setSummary]);
	return (
		<div className={Styles.HeaderContainer}>
			<h3 className={Styles.TimelineHeader}>
				<Flex>
					<Box marginTop="0.25rem">
						<Flex>
							<Box>
								<a className={Styles.CloseLink} href="#" onClick={onClickClose}>
									<RiArrowRightSLine className={Styles.CloseIcon} />
								</a>
							</Box>
							<Box w="15rem">
								<div
									className={Styles.RoomName}
								>{`${summary.deal.name} ${summary.deal.roomNumber}`}</div>
								<div className={Styles.PartnerName}>
									{isVendor
										? summary.deal.companySetting.name
										: summary.deal.originVendorCompany?.name}
								</div>
							</Box>
							{summary.lastSendAt !== null && (
								<Button
									disabled={isAdmin || isDisabledUnreadButton}
									height="small"
									marginLeft={16}
									onClick={onClickTemporaryUnread}
									variant="secondary"
								>
									未読ラベルをつける
								</Button>
							)}
						</Flex>
					</Box>
				</Flex>
			</h3>
			<div className={Styles.LinkWrapper}>
				<Link
					className={Styles.DealLink}
					href={
						isVendor
							? VENDOR_PATH(summary.deal.id)
							: CLIENT_PATH(summary.deal.id)
					}
					target="_blank"
				>
					案件詳細
				</Link>
			</div>
		</div>
	);
};
